import { Loading } from '@library/components/Loading';
import { NoResults } from '@library/components/NoResults';
import { PATHS } from '@bo-constants/routes';
import { SimulationLinks } from '@bo-components/simulations/SimulationLinks';
import type { SimulationRun } from '@library/types/simulations';

export interface StepFourPublishProps {
  gameId: string;
  leagueId: string;
  publishSimulationStatus: {
    isPublishSimulationError: boolean;
    isPublishSimulationLoading: boolean;
    isPublishSimulationSuccess: boolean;
  };
  simulation: SimulationRun;
}

export const StepFourPublish = ({
  gameId,
  leagueId,
  publishSimulationStatus,
  simulation
}: StepFourPublishProps) => {
  const {
    isPublishSimulationError,
    isPublishSimulationLoading,
    isPublishSimulationSuccess
  } = publishSimulationStatus;

  const { attributes } = simulation.data || {};
  const { simulation_run_name: simulationName } = attributes || {};

  if (isPublishSimulationLoading) {
    return (
      <Loading
        loadingMessage="Simulation Publication request has been Submitted. Please Wait for a
      response."
      />
    );
  }

  if (isPublishSimulationError) {
    return (
      <NoResults label="The Publication Request has failed. Please refresh and try again." />
    );
  }

  return (
    <div className="flex flex-row gap-4 py-6">
      {isPublishSimulationSuccess && (
        <div className="flex w-full flex-col items-center justify-center gap-8">
          <span className="text-soClean-100 text-lg font-medium">
            The simulation, {simulationName}, has been published!
          </span>
          <div className="flex w-full items-center justify-center gap-4">
            <SimulationLinks
              primaryLink={PATHS.TRADING}
              primaryLinkChildren="View Projections on Trading Dash"
              secondaryLink={`${PATHS.SIMULATIONS}/${leagueId}/${gameId}`}
              secondaryLinkChildren="Go Back to Game Simulations"
            />
          </div>
        </div>
      )}
    </div>
  );
};
